/** @jsx jsx */
import {
  // css,
  jsx,
} from "@emotion/react";
import { useContext } from "react";

import { DevNotice, useThemeProps } from "../../../../../../wsui/base";
import htmlStringifierContext from "../../../../../@whitespace/gatsby-theme-wordpress-basic/src/contexts/htmlStringifierContext";
import modularityModuleContext from "../../modularityModuleContext.js";

import ModuleController from "./ModuleController.jsx";

export default function WpModularityModule(props) {
  props = useThemeProps({ props, name: "WpModularityModule" });
  let { id: moduleDatabaseId, ...restProps } = props;
  let { contentModularityModules } = useContext(htmlStringifierContext);
  let module = contentModularityModules?.nodes?.find(
    (module) => module.databaseId === Number(moduleDatabaseId),
  );
  if (!module) {
    if (process.env.NODE_ENV !== "production") {
      return (
        <DevNotice>
          {`Module with id ${moduleDatabaseId} could not be found. (This message will not be visible in production.)`}
        </DevNotice>
      );
    }
    return null;
  }
  return (
    <modularityModuleContext.Provider
      value={{ hidden: false, module, columnWidth: null, ...restProps }}
    >
      <ModuleController module={module} />
    </modularityModuleContext.Provider>
  );
}
